export default __webpack_public_path__ + "static/media/Warning.47e668e9.svg";